// extracted by mini-css-extract-plugin
module.exports = {"result":"potential-contacts__result___8LPtn"};